/**
 * Build a WhatsApp deep link for a given phone number.
 * Returns null if the phone is missing or too short.
 */
export function buildWhatsAppLink(
  phone: string | null | undefined,
  talentName: string,
  senderContext: "empresa" | "admin" = "admin",
): string | null {
  if (!phone) return null;
  const digits = phone.replace(/\D/g, "");
  if (digits.length < 10) return null;
  const number = digits.startsWith("55") ? digits : `55${digits}`;
  const msg =
    senderContext === "empresa"
      ? `Olá ${talentName}, gostaríamos de conversar com você sobre uma oportunidade!`
      : `Olá ${talentName}, somos do Corre Digital! Gostaríamos de conversar com você sobre uma oportunidade.`;
  return `https://wa.me/${number}?text=${encodeURIComponent(msg)}`;
}
